import React from "react";
import { useDispatch } from "react-redux";
import { FiEdit } from "react-icons/fi";

import Tooltip from "@material-ui/core/Tooltip";
import Switch from "@material-ui/core/Switch";
import Popover from "@material-ui/core/Popover";
import ToggleButton from "@material-ui/lab/ToggleButton";
import ToggleButtonGroup from "@material-ui/lab/ToggleButtonGroup";
import Hidden from "@material-ui/core/Hidden";
import MenuItem from "@material-ui/core/MenuItem";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";

import { Form } from "../Header/AddProductPlusBtn/style";

import {
  renameCategory,
  removeCategory,
  changeVisibilityOfCategory,
} from "../../../Store/Modules/Menu/Actions";

import AddProductPlusBtn from "./AddProductPlusBtn";
import { Container, PanelTitle, Actions } from "./style";
import BtnRemoveCategory from "./BtnRemoveCategory";
import AddProductDialog from "./AddProductDialog";
import MoreVertMenu from "../../MoreVertMenu";
import { TrendingUpTwoTone } from "@material-ui/icons";
import { Typography } from "@material-ui/core";

export default function Header({ data: category, onToggle }) {
  const dispatch = useDispatch();

  const [anchorEl, setAnchorEl] = React.useState(null);

  const [openPopover, setOpenPopover] = React.useState(false);

  const [openRemoveCategory, setOpenRemoveCategory] = React.useState(false);

  const [openPopoverRenameCategory, setOpenPopoverRenameCategory] =
    React.useState(false);
  const [disabled, setDisabled] = React.useState(true);

  const handleSwitchChange = (input) => (event) => {
    dispatch(changeVisibilityOfCategory(category._id, event.target.checked));
  };

  const handleHeaderClick = () => {
    onToggle();
  };

  const handleRenameCategory = (evento) => {
    evento.preventDefault();
    dispatch(renameCategory(category._id, evento.target.nameShow.value));
    setOpenPopoverRenameCategory(false);
  };

  const handleOpenRenameCategory = (event) => {
    setAnchorEl(event.currentTarget);
    setOpenPopoverRenameCategory(true);
  };

  const handleClosePopoverRenameCategory = () => {
    setAnchorEl(null);
    setOpenPopoverRenameCategory(false);
  };

  const handleRemove = () => {
    dispatch(removeCategory(category._id));
  };

  const handleClickAddProduct = (event) => {
    setAnchorEl(event.currentTarget);
    setOpenPopover(true);
  };

  const handleClosePopoverAddProduct = () => {
    setAnchorEl(null);
    setOpenPopover(false);
  };

  const handleRemoveOpen = () => {
    setOpenRemoveCategory(true);
  };

  const handleRemoveClose = () => {
    setOpenRemoveCategory(false);
  };

  return (
    <Container>
      <PanelTitle onClick={handleHeaderClick}>{category.nameShow}</PanelTitle>
      <Actions>
        <Hidden xsDown={true}>
          <ToggleButtonGroup size="medium">
            <AddProductPlusBtn categoryId={category._id} />

            <Tooltip arrow placement="bottom" title="Renomear Categoria">
              <ToggleButton value="rename" onClick={handleOpenRenameCategory}>
                <FiEdit style={{ fontSize: "20px" }} />
              </ToggleButton>
            </Tooltip>

            <Tooltip arrow placement="bottom" title="Excluir Categoria">
              <BtnRemoveCategory
                categoryName={category.nameShow}
                onRemove={handleRemove}
              />
            </Tooltip>
          </ToggleButtonGroup>
        </Hidden>
        <Tooltip arrow placement="bottom" title="Ativar/Desativar Categoria">
          <Switch
            onChange={handleSwitchChange("is_active")}
            checked={category.is_active}
            color="primary"
          />
        </Tooltip>
        <Hidden smUp={true}>
          <MoreVertMenu>
            <MenuItem onClick={handleClickAddProduct}>
              Adicionar Produto
            </MenuItem>
            <MenuItem onClick={handleOpenRenameCategory}>
              Renomear Categoria
            </MenuItem>
            <MenuItem onClick={handleRemoveOpen}>Remover Categoria</MenuItem>
          </MoreVertMenu>
        </Hidden>
      </Actions>
      <Popover
        open={openPopover}
        anchorEl={anchorEl}
        onClose={handleClosePopoverAddProduct}
        anchorOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
      >
        <AddProductDialog
          onClose={handleClosePopoverAddProduct}
          categoryId={category._id}
        />
      </Popover>

      <Popover
        open={openPopoverRenameCategory}
        anchorEl={anchorEl}
        onClose={handleClosePopoverRenameCategory}
        anchorOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
      >
        <DialogContent>
          <Form onSubmit={handleRenameCategory}>
            <TextField
              label="Nome da categoria"
              name="nameShow"
              required
              autoFocus
              variant="outlined"
              size="small"
              autoComplete="off"
            />

            <Button type="submit" variant="contained" color="primary">
              Salvar
            </Button>
          </Form>
          <Button
            onClick={handleClosePopoverRenameCategory}
            color="default"
            style={{ float: "right" }}
          >
            Fechar
          </Button>
        </DialogContent>
      </Popover>

      <Dialog
        open={openRemoveCategory}
        onClose={handleRemoveClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle>
          Tem certeza que deseja excluir o <strong>{category.nameShow}</strong>?{" "}
        </DialogTitle>
        <DialogContent>
          <Typography>
            Digite <span style={{ color: "red" }}>delete</span> para confirmar a
            exclusão
          </Typography>
          <TextField
            variant="outlined"
            size="small"
            onChange={(e) => {
              if (e.target.value === "delete") {
                setDisabled(false);
              } else {
                setDisabled(true);
              }
            }}
          />
        </DialogContent>

        <DialogActions>
          <Button
            onClick={handleRemove}
            color="secondary"
            disabled={disabled}
            autoFocus
          >
            Sim
          </Button>
          <Button onClick={handleRemoveClose} color="default">
            Não
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
}
